import React from 'react';
import { Link } from 'react-router-dom';
import { PASSWORD_RESET_SCOPES } from '../lib/passwordReset';

/**
 * @param {{ scope: 'team' | 'marketplace', style?: React.CSSProperties, linkColor?: string }} props
 */
export default function ForgotPasswordLink({ scope, style, linkColor = '#5dcaa5' }) {
  const { forgotPath } = PASSWORD_RESET_SCOPES[scope];
  return (
    <p style={{ marginTop: 8, marginBottom: 0, textAlign: 'right', ...style }}>
      <Link
        to={forgotPath}
        style={{ color: linkColor, fontSize: '0.85rem', textDecoration: 'none' }}
      >
        Forgot password?
      </Link>
    </p>
  );
}
